import { CircularProgress } from '@material-ui/core';
import React from 'react';
import _ from 'lodash';
import './UploaderModal.scss';

const SingleDocumentViewer = (props) => {
    return (
        <div
            style={{
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'auto',
                background: '#f5f5f5'
            }}
        >
            {_.isEmpty(props.imageList) ? (
                <CircularProgress color="secondary" />
            ) : (
                <>
                    {props.slectedFileExt === '.pdf' ? (
                        <iframe
                            src={props.imageList}
                            id="editviewer"
                            frameBorder="0"
                            scrolling="auto"
                            allowFullScreen
                            width="100%"
                            height="100%"
                            style={{
                                objectFit: 'contain'
                            }}
                        />
                    ) : (
                        <img
                            src={props.imageList}
                            alt="No document selected"
                            id="printableImage"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain'
                            }}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default SingleDocumentViewer;
